// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7083a96a","769":"366aaf53"}[chunkId] + ".chunk.js";
};